// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 5253 ? "courses-overview" : chunkId) + "." + {"5253":"60686d77","9738":"b9bd4fc3"}[chunkId] + ".css";
};